(function () {
  'use strict';

  var CART_ICON_SELECTOR = '#cart-icon-bubble, a.header__icon--cart';

  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  function prepareCartIcons() {
    document.querySelectorAll(CART_ICON_SELECTOR).forEach(function (element) {
      var link = element.matches('a') ? element : element.closest('a');
      if (!link) return;
      link.href = cartUrl();
      link.removeAttribute('aria-controls');
    });
  }

  document.addEventListener('click', function (event) {
    var cartIcon = event.target.closest(CART_ICON_SELECTOR);
    if (!cartIcon) return;

    /* Never intercept cart line controls such as /cart/change remove links. */
    if (event.target.closest('cart-remove-button, [data-screwman-cart-remove], .cart-item__remove-btn, .cart-remove-button')) {
      return;
    }

    var link = cartIcon.matches('a') ? cartIcon : cartIcon.closest('a');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(cartUrl());
  }, true);

  document.addEventListener('DOMContentLoaded', prepareCartIcons);
  document.addEventListener('shopify:section:load', prepareCartIcons);
  document.addEventListener('screwman:cart-rendered', prepareCartIcons);
  document.addEventListener('screwman:cart-added', prepareCartIcons);

  if (document.readyState !== 'loading') prepareCartIcons();
})();
